export const uk = {
    'active-banners': 'Активные объявления',
    'active-campaigns': 'Активные кампании',
    'active-cpc-campaigns': 'Активные кампании с оплатой за клики',
    'active-cpm-campaigns': 'Активные кампании c оплатой за показы',
    'active-groups': 'Активные группы',
    'all-active-groups': 'Активные группы',
    'all-archived-groups': 'Архивные группы',
    'all-banners': 'Все объявления',
    'all-campaigns': 'Все кампании',
    'all-cpc-campaigns': 'Кампании с оплатой за клики',
    'all-cpm-campaigns': 'Кампании c оплатой за показы',
    'all-groups': 'Все группы',
    'all-phrases': 'Все фразы',
    'all-targetings': 'Все условия показа',
    'archive-banners': 'Архивные объявления',
    'archive-campaigns': 'Архивные кампании',
    'archive-cpc-campaigns': 'Архивные кампании с оплатой за клики',
    'archive-cpm-campaigns': 'Архивные кампании c оплатой за показы',
    'archive-groups': 'Архивные группы',
    'archived-status': 'Архив',
    banners: 'Объявления',
    'cpc-campaigns': 'За клики',
    'cpm-campaigns': 'За показы',
    'draft-status': 'Черновик',
    'minus-phrase-binding-error-grid-alert-message':
        'К этим группам не удалось привязать наборы минус-фраз. Возможно, уже привязано максимальное количество наборов',
    'minus-phrase-unbinding-error-grid-alert-message': 'У этих групп не удалось отвязать наборы минус-фраз',
    'pause-status': 'Временно остановлено',
    phrases: 'Фразы',
    'regions-transform-error-grid-alert-message': 'В этих группах не удалось изменить регионы показов',
    'run-ok-status': 'Активно',
    'run-warn-status': 'Активно с ограничением',
    'stop-status': 'Остановлено',
    targetings: 'Таргетинги'
};
